const messages = {
    actions: {
        confirm: "Conferma",
        download: "Scarica",
        cancel: "Annulla",
        retry: "Riprova",
        close: "Chiudi",
        save: "Salva",
        search: "Cerca",
        buy: "Acquista",
        next: "Avanti",
        prev: "Indietro",
    },
    general: {
        loading: "Caricamento in corso",
        showAll: "Mostra tutti",
        searchCompany: "Cerca un'azienda",
        updateCredits: "Aggiornamento crediti utente",
        noSearchPlaceholderTitle: "Cerca l'azienda",
        noSearchPlaceholderSubtitle:
            "Inserisci Ragione Sociale, Codice Fiscale o Partita IVA per avviare la ricerca.",
        noResultsPlaceholderTitle: "Nessun risultato trovato",
        noResultsPlaceholderSubtitle:
            'Non sono stati trovati risultati per "{term}"',
        pending: "In elaborazione",
        lastBought: "Ultimo acquisto",
        year: "anno",
        date: "Data",
        addLabel: "Aggiungi etichetta",
        otherLabels: "Altre etichette",
    },
    menu: {
        buy: "Acquista",
        documents: "Documenti acquistati",
    },
    main: {
        titles: {
            step1: "Ricerca azienda",
            step2: "Documenti disponibili per ",
            noOrdersTitle:
                "Acquista i documenti delle aziende che ti interessano",
            noOrdersSubtitle:
                "Cerca un'azienda e scegli tra visure, bilanci e report. Acquista i documenti con i tuoi crediti e consultali quando vuoi.",
        },
    },
    orders: {
        statuses: {
            COMPLETE: "Completato",
            PENDING: "In elaborazione",
            ERROR: "Errore",
            NEW_REQUEST: "Nuova Richiesta",
        },
        lastOrders: "Documenti acquistati di recente",
        buyDocuments: "Acquista documenti",
        noOrders: "Non hai ancora acquistato documenti",
    },
    onboarding: {
        title: "Benvenuto in Business Information",
        button: "Inizia",
        tip: "Ti bastano pochi minuti",
        copyright1:
            "Ti informiamo che i servizi della piattaforma Business Information sono erogati da ",
        copyright2: "Modefinance S.r.l.",
        copyright3:
            ", con sede legale in Science Park, Padriciano 99,  34149 Trieste (TS), P.IVA 01168840328",
        subtitle:
            "La soluzione che ti consente di ottenere informazioni relative ad aspetti societari, finanziari, economici e settoriali di tutte le aziende di tuo interesse.",
        threesteps:
            "3 semplici passi per acquistare documenti che ti occorrono",
        onestep: "Un semplice passo per acquistare documenti che ti occorrono",
        steps: {
            title: "3 semplici passi per acquistare i documenti che ti occorrono",
            step1: "Inserisci Nome, Cognome e Codice Fiscale del legale rappresentante",
            step2: "Carica fronte e retro della carta d’identità del legale rappresentante",
            step3: "Accetta i termini del servizio e prendi visione dell'informativa privacy",
        },
        benefits: {
            title: "I vantaggi di Business Information",
            title1: "Ricerca semplice e veloce",
            description1:
                "Ricerca velocemente le aziende tramite la partita iva, il codice fiscale o la ragione sociale. Per ogni azienda visualizzi subito quali sono i documenti disponibili.",
            title2: "Costo trasparente",
            description2:
                "Il costo dei documenti è definito in termini di crediti ed è sempre visibile all’interno del servizio in prossimità dei diversi documenti disponibili.",
            title3: "Storico degli acquisti",
            description3:
                "Accedi allo storico degli acquisti per scaricare in qualsiasi momento una copia dei documenti.",
        },
        requirements: {
            title: "Per configurare Business Information avrai bisogno dei seguenti documenti del legale rappresentante:",
            fiscalCode: "Codice fiscale",
            identityCard: "Foto fronte e retro della carta d'identità",
        },
        confirm: "CONFERMA",
        identityCard: "Carta d’identità",
        data: "LEGALE RAPPRESENTANTE",
        dataSub:
            "Inserisci i dati anagrafici del Legale Rappresentante e carica la relativa carta d’identità in corso di validità",
        registryData: "Informazioni anagrafiche",
        list1: "Compila il form con i dati anagrafici",
        list2: "Carica le foto della tua Carta d’identità",
        list3: "Conferma la veridicità delle informazioni inserite",
        listPrivacy1: "Presa visione e consensi",
        listTitle: "LEGALE RAPPRESENTANTE",
        listTitlePrivacy: "INFORMATIVA PRIVACY",
        errorTitle: "Invio non riuscito",
        errorDescription:
            "Un errore imprevisto non ci ha permesso di inviare i dati.",
        deadline: "Data di scadenza del documento",
        privacy:
            "TERMINI E CONDIZIONI del SERVIZIO e TRATTAMENTO DEI DATI PERSONALI",
        privacySub:
            "Per attivare il servizio abbiamo bisogno che tu prenda visione dei <a>termini e condizioni del servizio</a> e che ci confermi di accettarli integralmente:",
        privacy1: "Accetto i <a>termini e condizioni del servizio</a>",
        privacy2:
            "Accetto in particolare le seguenti clausole dei predetti termini e condizioni del servizio: art. 3.1 (Obblighi del Cliente); artt. 4.3, 4.4., 4.5, 4.6, 4.7 (Adeguamento dei Corrispettivi, modifica unilaterale dei Corrispettivi, conseguenze del mancato pagamento e solve et repete); art. 8 (Responsabilità del Cliente nell’uso dei Servizi e in relazione ai Terzi Beneficiari, limitazioni di responsabilità di Modefinance, diritto di sospensione dei Servizi), art. 9 (Diritti di Proprietà Intellettuale di Modefinance e limitazioni in capo al Cliente); art. 10 (Obblighi di manleva del Cliente); art. 11 (Limitazioni di responsabilità di Modefinance); art. 12 (Modifiche Unilaterali); art. 13 (Diritto di recesso di Modefinance); art. 14 (Clausola risolutiva espressa e interdizione del Cliente dai Servizi); art. 16 (Foro esclusivo); art 17 (Divieto di cessione).",
        privacySub2:
            "Ti invitiamo inoltre a consultare la nostra <a>informativa sul trattamento dei dati personali</a> e a indicarci di seguito le scelte che intendi effettuare sui consensi da rilasciare a Modefinance per le seguenti finalità indicate nella nostra informativa:",
        privacy3:
            "Acconsento al trattamento dei miei dati per ricevere via email, posta, messaggi istantanei, chat o telefono novità e offerte commerciali su prodotti e servizi Modefinance",
        privacy4:
            "acconsento a condividere i miei dati personali con le altre società del gruppo TeamSystem e i suoi partner per essere trattati a fini commerciali e di marketing",
    },
    feedbacks: {
        buy: {
            okTitle: "OK",
            okMessage: "Prodotto acquistato con successo",
            errorTitle: "ERRORE",
            errorMessage:
                "Si è verificato un errore durante l'acquisto del documento",
            aggregatedProductsErrorMessage:
                "Si è verificato un errore durante l'acquisto dei documenti",
        },
    },
    modals: {
        buy: {
            title: "Conferma l'acquisto",
            buying: "Stai acquistando",
            transferDescription1:
                "Seleziona le date per la ricerca degli atti di trasferimento azienda, il range è fissato a 6 mesi, quindi ti basterà selezionare la data di fine, e il sistema in automatico aggiornerà la data di inizio.",
            transferDescription2:
                "La Lista Atti di Trasferimento Azienda necessaria per procedere allo step successivo ha un costo di 2 crediti",
            description1:
                "Per completare l’operazione seleziona “Acquista”. Ti verranno scalati",
            description2: "crediti in automatico.",
            spinner: "Acquisto prodotto in corso...",
            spinnerList: "Ottengo lista atti trasferimenti azienda...",
            balance: {
                step1: "Scegli tipo di bilancio e anno",
                step2: "Completa l'acquisto",
                selectOption: "Seleziona un'opzione",
                consolidated: "Consolidato",
                ordinary: "Ordinario",
                type: "Scegli il tipo di bilancio *",
                year: "Scegli l'anno del bilancio *",
            },
            transfer: {
                step1: "Scegli le date",
                step2: "Completa l'acquisto",
                startDate: "da data",
                endDate: "a data",
                kdoc: "Seleziona un documento da acquistare",
            },
        },
    },
    widgets: {
        credits: {
            title: "I tuoi crediti",
            extra: "Il tuo pacchetto prevede l'extrasoglia",
            extraTooltipTitle: "Crediti extrasoglia attiva",
            extraTooltipDescription:
                "Con i crediti extrasoglia puoi continuare ad acquistare documenti anche quando hai consumato il pacchetto di Business Information. Ti fattureremo i crediti extra a fine anno.",
            negativeTooltipTitle: "Credito insufficiente",
            negativeTooltipDescription:
                "Non hai crediti di Business Information sufficienti per acquistare documenti. Rivolgiti al tuo referente commerciale per acquistare un nuovo pacchetto.",
        },
        companyCard: {
            vatNumber: "P.IVA",
            fiscalCode: "C.F.",
            rea: "REA",
        },
        productCard: {
            format: "Formato",
            price: "Prezzo",
            credits: "crediti",
        },
        uploader: {
            tip: "Puoi caricare un'immagine in formato .jpg o .png di massimo 1 MB.",
        },
    },
    errors: {
        uploader: "Errore durante il caricamento del file.",
    },
    policy: {
        message:
            'Il servizio "Business Information" costituisce "servizio di informazione commerciale" ed è fornito da modefinance S.r.l., con sede legale in Trieste, loc. Padriciano 99 e in forza di licenza ai sensi dell\'art. 134 TULPS. Nell\'erogazione del servizio modefinance S.r.l. agisce quale titolare del trattamento dei dati personali. Maggiori informazioni sono disponibili nella sezione <a>https://privacy.modefinance.com/it</a> ',
    },
    trial: {
        button: "Acquista licenza",
        messageSoon:
            "Il tuo periodo di prova di TS Business Information terminerà presto.",
        message:
            "Il tuo periodo di prova di TS Business Information terminerà tra {days} giorni.",
        messageExpired:
            "Il tuo periodo di prova di TS Business Information è scaduto. Acquista la licenza sullo store di TeamSystem.",
        placeholderExpired: "Il tuo periodo di prova è scaduto",
        placeholderExpiredSubtitle:
            "Per continuare a utilizzare TS Business Information, acquistalo sullo store TeamSystem!",
        noSearchPlaceholderTitle: "Il tuo periodo di prova è scaduto",
        noSearchPlaceholderSubtitle:
            "Per continuare a utilizzare TS Business Information, acquistalo sullo store TeamSystem!",
    },
};

export default messages;
